import { useFeatureIsOn } from '@growthbook/growthbook-react'

import { useRecommendedForYouArticlesQuery } from '../../../../generated/frontend'
import { AssociatedArticles } from '../../../../shared/components'
import { Layout, Model } from '../../../../shared/components/RecommendedForYou'
import { ModelRecommendations } from '../../../../shared/components/RecommendedForYou/components/ModelRecommendations/ModelRecommendations'
import {
  getModelsData,
  type RecommendedModelType,
} from '../../../../shared/components/RecommendedForYou/models'

type AssociatedArticlesProps = React.ComponentProps<typeof AssociatedArticles>
type ContentExperimentProps = {
  recommendedModel: RecommendedModelType
} & AssociatedArticlesProps

const ContentExperiment = ({
  recommendedModel,
  ...associatedArticlesProps
}: ContentExperimentProps) => {
  const showR4U = useFeatureIsOn('DSP-018-replace-related-content-with-r4u')

  if (showR4U) {
    return (
      <ModelRecommendations
        model={recommendedModel}
        whichId={'related links'}
        layout={Layout.TextLinks}
      />
    )
  }

  return <AssociatedArticles {...associatedArticlesProps} />
}

export const RecommendedForYouPageBody = (associatedArticlesProps: AssociatedArticlesProps) => {
  const { data, loading } = useRecommendedForYouArticlesQuery()

  if (loading) {
    return null
  }

  const allModels = getModelsData(data?.homePage.recommendations?.models ?? [])
  const mixedAdviceModel = allModels[Model.MIXED_ADVICE]

  if (mixedAdviceModel) {
    return <ContentExperiment recommendedModel={mixedAdviceModel} {...associatedArticlesProps} />
  }

  return <AssociatedArticles {...associatedArticlesProps} />
}
